import { render, staticRenderFns } from "./BlogDetails.vue?vue&type=template&id=4bbc9bec&scoped=true&"
import script from "./BlogDetails.vue?vue&type=script&lang=js&"
export * from "./BlogDetails.vue?vue&type=script&lang=js&"
import style0 from "./BlogDetails.vue?vue&type=style&index=0&id=4bbc9bec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bbc9bec",
  null
  
)

export default component.exports